/**
 * <DOCUMENT ME!>
 *
 * File: \tests\init.js
 * Created Date: Monday, July 10th 2023, 11:13:11
 * Author: Herrmann Sascha (HAU-EDCP)
 * -----
 * Last Modified: July 10th 2023, 11:13:11
 * Modified By: Herrmann Sascha (HAU-EDCP)
 * -----
 * Copyright (c) 2017-2023 Liebherr-Hausgeräte GmbH
 */

// Vite (unlike Webpack) does not the window.global
window.global ||= window;

if (import.meta.env.VITE_ENVIRONMENT === 'localforward') {
  document.title = 'LOCALFORWARD';
}

if (import.meta.env.VITE_ENVIRONMENT === 'localhost') {
  document.title = 'LOCALHOST';
}
